<template>
    <v-container class="pa-0 px-2">
        <v-row>
            <v-col v-for="product in products" :key="product.id" cols="6" sm="4" lg="3" xl="2" class="p-lr pb-0">
                <v-card
                    outlined
                    tile
                    hover
                    :ripple="false"
                    :to="`/${type}/p/${product._id}`"
                >
                    <!-- :disabled="loaded.indexOf(product.id)==-1" -->
                    
                    <v-img :src="product.image" class="grey lighten-3" height="200" @load="loaded.push(product.id)">
                        <!-- <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="blue lighten-5"></v-progress-circular>
                            </v-row>
                        </template> -->
                        <!-- <v-card class="d-inline-block px-2 py-1 ma-2 text-subtitle-2 grey darken-3" dark>
                            {{ product.s1 }}
                        </v-card> -->
                    </v-img>
                    <v-card-title
                        class="align-start font-weight-bold text-subtitle-2"
                        style="height: 66px; overflow: hidden;"
                    >
                        {{product.title}}
                    </v-card-title>

                    <v-card-text class="text-subtitle-2">
                        <!-- {{ product.s1 || '' }} {{product.s2 ? `> ${product.s2}` : ``}} -->
                        <v-row class="px-4 pt-4">
							<v-col class="pa-0 text-truncate" style="overflow: hidden;">
								<span>{{product.storeName}}</span>
							</v-col>
							<v-col class="pa-0 text-right">
								<span class="black--text" style="white-space: nowrap;">{{(product.price==0 ? `Free` : `${product.price.toLocaleString()} บาท`)}}</span>
							</v-col>
						</v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: ["products", "type"],
    methods: {
    },
    data() {
        return {
            loaded: []
        };
    }
};
</script>

<style scoped>
.p-lr {
    padding-left: 6px;
    padding-right: 6px;
}
</style>